import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07368da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asSubscription" }
const _hoisted_2 = {
  key: 0,
  class: "section"
}
const _hoisted_3 = { class: "caption" }
const _hoisted_4 = { class: "subscriptions" }
const _hoisted_5 = {
  key: 1,
  class: "section"
}
const _hoisted_6 = { class: "caption" }
const _hoisted_7 = { class: "subscriptions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_subscription = _resolveComponent("as-subscription")!
  const _component_as_empty = _resolveComponent("as-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.subscriptionGrouped.active && _ctx.subscriptionGrouped.active.subscriptions.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.subscriptionGrouped.active.title), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionGrouped.active.subscriptions, (subscription) => {
              return (_openBlock(), _createBlock(_component_as_subscription, {
                key: subscription.id,
                subscription: subscription,
                link: subscription.status === 'Active',
                onClick: ($event: any) => (_ctx.openSubscription(subscription))
              }, null, 8, ["subscription", "link", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.subscriptionGrouped.other && _ctx.subscriptionGrouped.other.subscriptions.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.subscriptionGrouped.other.title), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionGrouped.other.subscriptions, (subscription) => {
              return (_openBlock(), _createBlock(_component_as_subscription, {
                key: subscription.id,
                subscription: subscription,
                link: subscription.status === 'Active',
                onClick: ($event: any) => (_ctx.openSubscription(subscription))
              }, null, 8, ["subscription", "link", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.subscriptions.length === 0)
      ? (_openBlock(), _createBlock(_component_as_empty, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}